import React from 'react'


const WorkCard = (props) => {
  const {img, title, text, link, demo} = props;
  return (
    <div className='w-[500px] my-4 mx-4 h-auto rounded-2xl'>
        <img className='w-full rounded-t-2xl' src={img} alt="work" />
        <div className='textPlate py-4 px-4 md:px-8 border-[0.1px] border-t-0 border-[#41414138] rounded-b-2xl'>
        <p className='text-3xl text-[#0f8f80] font-medium my-2'>{title}</p>
        <p className='my-2 font-thin'>{text}</p>
        <a href={link} rel="noreferrer" target="_blank" className='mx-2 my-2 text-sm'>Code</a>
        <a href={demo} rel="noreferrer" target="_blank" className='my-2 mx-2 text-sm'>Demo</a>
        </div>
    </div>
  )
}

export default WorkCard
